import React, { useEffect, useState } from 'react'
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect'
import DatePicker from 'react-datepicker'
import { Tooltip } from 'antd'
import { FileProtectOutlined } from '@ant-design/icons'
import moment from 'moment'
import ProtectionModel from '../components/ProtectionModel'
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { SimulatorModel } from '../models/SimulatorModel'
import { calculateAge } from "../utils/dateUtils";


interface ICarAndDriversDetails {
    productionData: any,
    offer: any,
    setStateData: (name: string, e: any) => void,
    // setStateInputData: (name: string, e: any) => void,
    geder: any,
    authorizedToDrive: any,
    vehicleOwnership: any,
    maritalStatus: any,
    mainLicenseDateRef: any,
    youngLicenseDateRef: any,
    setCheckboxStateData: any,
    setCheckboxStateDataYoung: (name: string, event: any) => void,
    renderValidationError: (name: string) => React.ReactNode,
    setAlertMessege: (e: any, navigate: string) => void,
    oldData: any
}

const CarAndDriversDetails: React.FC<ICarAndDriversDetails> = ({
    productionData,
    offer,
    setStateData,
    // setStateInputData,
    geder,
    authorizedToDrive,
    vehicleOwnership,
    maritalStatus,
    mainLicenseDateRef,
    youngLicenseDateRef,
    setCheckboxStateData,
    setCheckboxStateDataYoung,
    renderValidationError,
    setAlertMessege,
    oldData
}) => {

    const [ownerIsMainDriver, setOwnerIsMainDriver] = useState<boolean>(productionData.ownerIsMainDriver);
    const [ownerIsYoungDriver, setOwnerIsYoungDriver] = useState<boolean>(productionData.ownerIsYoungDriver);
    const [showProtection, setShowProtection] = useState<boolean>(false);

    const [driverMainBirthDate, setDriverMainBirthDate] = useState<Date | null>(null);
    const [driverMainSeniorityDate, setDriverMainSeniorityDate] = useState<Date | null>(null);

    const [driverYoungDateOfBirth, setDriverYoungDateOfBirth] = useState<Date | null>(null);
    const [driverYoungSeniorityDate, setDriverYoungSeniorityDate] = useState<Date | null>(null);


    const GUID_EMPTY = '00000000-0000-0000-0000-000000000000'

    useEffect(() => {
        //
        if (!productionData.ownerIsMainDriver && productionData.driverMainFirstName === productionData.ownerFirstName
            && productionData.driverMainIdentifier === productionData.ownerIdentifier) {
            setStateData('driverMainFirstName', "");
            setStateData('driverMainLastName', "");
            setStateData('driverMainIdentifier', "");
        }

        if (productionData.ownerIsMainDriver && productionData.driverMainFirstName === productionData.ownerFirstName
            && productionData.driverMainLastName === productionData.ownerLastName) {

            setStateData('driverMainIdentifier', productionData.ownerIdentifier);

        }

        if (/*productionData.mainDriverCustomer*/true) {
            setDriverMainBirthDate(productionData.offer.driverMainBirthDate);
            setDriverMainSeniorityDate(productionData.offer.driverMainSeniorityDate);

        }

        if (/*productionData.youngDriverCustomer*/true) {
            setDriverYoungDateOfBirth(productionData.offer.driverYoungBirthDate);
            setDriverYoungSeniorityDate(productionData.offer.driverYoungSeniorityDate);
            if (productionData.authorizedToDrive == 2) {

                productionData.driverYoungBirthDate = productionData.offer.driverYoungBirthDate;
                productionData.driverYoungSeniorityDate = productionData.offer.driverYoungSeniorityDate;
            }
        }
    }, [])


    const setCheckBox = (name: string, e: any) => {
        //
        console.log('driverMainBirthDate', productionData.driverMainBirthDate)
        console.log('ownerCustomer.dateOfBirth', productionData.ownerDateOfBirth)

        console.log("ownerIsMainDriver", e.target.value)

        if (e.target.checked) {

            if (driverMainBirthDate && calculateAge(new Date(driverMainBirthDate), new Date(productionData.startDate)) != calculateAge(productionData.ownerDateOfBirth, new Date(productionData.startDate))) {
                setAlertMessege("תאריך הלידה של הלקוח שונה,", 'simulator')
                return;
            }
            // else if (driverMainSeniorityDate && calculateAge(new Date(driverMainSeniorityDate)) != calculateAge(productionData.ownerCustomer.driverLicensIssueDate)) {
            //     setAlertMessege("תאריך תחילת רשיון של הלקוח שונה,", 'simulator')
            //     return;
            // }
            else if (productionData.driverMainMaritalStatus != productionData.ownerMaritalStatus && productionData.ownerIsMainDriver == false) {
                setAlertMessege("מצב המשפחתי של הלקוח שונה,", 'simulator')
                return;
            } else if (productionData.driverMainGender != productionData.ownerGender && productionData.ownerIsMainDriver == false) {
                setAlertMessege("סוג מגדר של הלקוח שונה,", 'simulator')
                return;
            } else {
                setOwnerIsMainDriver((state) => !state)
                setCheckboxStateData("ownerIsMainDriver", e)
            }
        }
        else {
            setOwnerIsMainDriver((state) => !state)
            setCheckboxStateData("ownerIsMainDriver", e)
        }
    }

    const setCheckBoxYoungDriver = (name: string, e: any) => {
        console.log("youngDriverIsMainDriver", e.target.value)

        if (e.target.checked) {
            if (driverYoungDateOfBirth && calculateAge(new Date(driverYoungDateOfBirth), new Date(productionData.startDate)) != calculateAge(productionData.ownerDateOfBirth, new Date(productionData.startDate))) {
                setAlertMessege("תאריך הלידה של הלקוח שונה,", 'simulator')
                return;
            } else if (productionData.driverYoungMaritalStatus != productionData.ownerMaritalStatus && productionData.youngDriverIsMainDriver == false) {
                setAlertMessege("מצב המשפחתי של הלקוח שונה,", 'simulator')
                return;
            } else if (productionData.driverYoungGender != productionData.ownerGender && productionData.youngDriverIsMainDriver == false) {
                setAlertMessege("סוג מגדר של הלקוח שונה,", 'simulator')
                return;
            } else {
                setOwnerIsYoungDriver((state) => !state)
                setCheckboxStateDataYoung("ownerIsYoungDriver", e)
            }
        } else {
            setOwnerIsYoungDriver((state) => !state)
            setCheckboxStateDataYoung("ownerIsYoungDriver", e)
        }
    }

    const emptyDate = (date: string) => {
        if (!date)
            return true;
        const _date = new Date(date);
        if (_date.getFullYear() === 1 && _date.getMonth() === 0 && _date.getDate() === 1)
            return true;
        return false;
    }

    // const getAge = (birthDate: Date) => {
    //     const today = new Date(productionData.startDate);// new Date();
    //     let age = today.getFullYear() - birthDate.getFullYear();

    //     const monthDiff = today.getMonth() - birthDate.getMonth();
    //     if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    //         age--;
    //     }
    //     return age;
    // }

    const setCarData = (name: string, value: any) => {

        if (name === "licenseNumber") {
            if (oldData != null && oldData.vehicle != null && oldData.vehicle.licenseNumber != null) {
                setAlertMessege("לשינוי מספר רישוי", 'lead');
                return;
            }
        }

        if (name === "modelCode") {
            setAlertMessege('לשינוי קוד דגם הרכב ', 'simulator');
            return;
        }
        if (name === "carYear") {
            if (oldData != null && oldData.vehicle != null && oldData.vehicle.carYear != null) {
                setAlertMessege('לשינוי שנת הרכב ', 'simulator');
                return;
            }
        }
        if (name === "vehicleOwnership") {
            setAlertMessege('לשינוי בעלות הרכב ', 'simulator');
            return;
        }


        console.log('name', name)
        console.log('e.target.value', value);
        const vehicleData = productionData.vehicle;
        if (name === "vehicleModel") {
            vehicleData.vehicleSubModel[name] = value;
        } else {
            vehicleData[name] = value;
        }
        setStateData('vehicle', vehicleData);
    }

    const setMainDriverCustomer = (name: string, value: any) => {

        if (name === "driverMainMaritalStatus") {
            setAlertMessege('לשינוי מצב משפחתי של הנהג העיקרי ', 'simulator');
            return;
        }
        if (name === "driverMainGender") {
            setAlertMessege('לשינוי מגדר הנהג העיקרי', 'simulator');
            return;
        }

        productionData[name] = value;
        setStateData(name, value);
    }


    const setMainDriverCustomerIdentifier = async (name: string, value: any) => {

        //%%

        if (value.length > 7 && value.length < 10) {
            const customerDetails: any = await new SimulatorModel().getCustomerDetailsById(value);
            if (customerDetails && customerDetails.customer) {
                if (driverMainBirthDate && calculateAge(new Date(driverMainBirthDate), new Date(productionData.startDate)) != calculateAge(new Date(customerDetails.customer.dateOfBirth.replace('T', ' ')), new Date(productionData.startDate))) {
                    setAlertMessege("תאריך הלידה של הלקוח שונה,", 'simulator')
                    return;
                }

                productionData.driverMainFirstName = customerDetails.customer.firstName;
                productionData.driverMainLastName = customerDetails.customer.lastName;
                productionData.driverMainGender = customerDetails.customer.gender;
                productionData.driverMainMaritalStatus = customerDetails.customer.maritalStatus;
                const bDate = new Date(customerDetails.customer.dateOfBirth.replace('T', ' '));
                productionData.driverMainBirthDate = bDate;


            }
        }

        productionData.driverMainIdentifier = value;
        setStateData("driverMainFirstName", productionData.driverMainFirstName);
        setStateData("driverMainLastName", productionData.driverMainLastName);
        setStateData("driverMainGender", productionData.driverMainGender);
        setStateData("driverMainBirthDate", productionData.driverMainBirthDate);
        setStateData("driverMainMaritalStatus", productionData.driverMainMaritalStatus);
    }



    const setYoungDriverCustomer = (name: string, value: any) => {

        if (name === "driverYoungMaritalStatus") {
            setAlertMessege('לשינוי מצב משפחתי של הנהג הצעיר ', 'simulator');
            return;
        }
        if (name === "driverYoungGender") {
            setAlertMessege('לשינוי מגדר הנהג הצעיר', 'simulator');
            return;
        }

        productionData[name] = value;
        setStateData(name, value);
    }

    const setYoungDriverCustomerIdentifier = async (name: string, value: any) => {

        //%%
        var _productionData = productionData;
       
        if (value.length > 7 && value.length < 10) {
            const customerDetails: any = await new SimulatorModel().getCustomerDetailsById(value);
            if (customerDetails && customerDetails.customer) {
                if (driverYoungDateOfBirth && calculateAge(new Date(driverYoungDateOfBirth), new Date(productionData.startDate)) != calculateAge(new Date(customerDetails.customer.dateOfBirth.replace('T', ' ')), new Date(productionData.startDate))) {
                    setAlertMessege("תאריך הלידה של הלקוח שונה,", 'simulator')
                    return;
                }

                _productionData.driverYoungFirstName = customerDetails.customer.firstName;
                _productionData.driverYoungLastName = customerDetails.customer.lastName;
                _productionData.driverYoungGender = customerDetails.customer.gender;
                _productionData.driverYoungMaritalStatus = customerDetails.customer.maritalStatus;
                const bDate = new Date(customerDetails.customer.dateOfBirth.replace('T', ' '));
                _productionData.driverYoungBirthDate = bDate;
                _productionData.driverYoungIdentifier = value;
                // const dDate = new Date(customerDetails.customer.driverLicensIssueDate.replace('T', ' '));
                // youngDriverCustomer.driverLicensIssueDate = dDate;
            }
        }



        setStateData('driverYoungFirstName', _productionData.driverYoungFirstName);
        setStateData('driverYoungLastName', _productionData.driverYoungLastName);
        setStateData('driverYoungGender', _productionData.driverYoungGender);
        setStateData('driverYoungMaritalStatus', _productionData.driverYoungMaritalStatus);
        setStateData('driverYoungBirthDate', _productionData.driverYoungBirthDate);
        setStateData('driverYoungIdentifier', value);
    }


    // const calculateAge = (dateOfBirth: Date) => {
    //     const today = new Date(productionData.startDate);// new Date(); 
    //     const birthDate = new Date(dateOfBirth);
    //     let age = today.getFullYear() - birthDate.getFullYear();
    //     const monthDiff = today.getMonth() - birthDate.getMonth();

    //     // Check if the birthday has not occurred yet this year
    //     if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    //         age--;
    //     }
    //     return age;
    // }


    const handleChangeRaw = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
        //
        const value = e.target.value;

        // Parse typed string
        // const parsedDate = parse(value, 'dd/MM/yyyy', new Date());

        // // Only trigger calcAge if full and valid
        // if (isValid(parsedDate) && value.length === 10) {
        //   calcAge(parsedDate, 'driverMainSeniorityDate');
        // }
    };

    const calcAge = (e: any, name: string) => {
        
        var _productionData = productionData;
        console.log('e :>> ', e);
        if (productionData != null) {
            var birthDate = e;
            if (birthDate != null) {

                // var diff_ms = new Date(productionData.startDate).getTime() - e.getTime();

                // var age_dt = new Date(diff_ms);
                // var age = Math.abs(age_dt.getUTCFullYear() - 1970);

                var age = calculateAge(new Date(birthDate), new Date(productionData.startDate))

                
                switch (name) {
                    case "driverMainSeniorityDate": {
                        if (driverMainSeniorityDate && calculateAge(new Date(driverMainSeniorityDate), new Date(productionData.startDate)) != age) {
                            setAlertMessege('לשינוי תאריך הוצאת רשיון נהיגה של הנהג העיקרי', 'simulator');
                            return;

                        }
                        _productionData.driverMainSeniorityDate = e;
                        _productionData.driverMainSeniority = age;
                        setStateData('driverMainSeniorityDate', _productionData.driverMainSeniorityDate);
                        setStateData('driverMainSeniority', _productionData.driverMainSeniority);
                        break;
                    }
                    case "driverMainBirthDate": {
                        if (driverMainBirthDate && calculateAge(new Date(driverMainBirthDate), new Date(productionData.startDate)) != age) {
                            setAlertMessege('לשינוי תאריך לידה של הנהג העיקרי', 'simulator');
                            return;
                        }
                        _productionData.driverMainBirthDate = e;
                        setStateData('driverMainBirthDate', _productionData.driverMainBirthDate);
                        break;
                    }
                    case "driverYoungBirthDate": {
                        if (driverYoungDateOfBirth && calculateAge(new Date(driverYoungDateOfBirth), new Date(productionData.startDate)) != age) {
                            setAlertMessege('לשינוי תאריך לידה של הנהג הצעיר', 'simulator');
                            return;
                        }
                        _productionData.driverYoungBirthDate = e;
                        setStateData('driverYoungBirthDate', _productionData.driverYoungBirthDate);
                        break;
                    }
                    case "driverYoungSeniorityDate": {
                        if (driverYoungSeniorityDate && calculateAge(new Date(driverYoungSeniorityDate), new Date(productionData.startDate)) != age) {
                            setAlertMessege('לשינוי תאריך הוצאת רשיון נהיגה של הנהג הצעיר', 'simulator');
                            return;
                        }
                        _productionData.driverYoungSeniority = age;
                        _productionData.driverYoungSeniorityDate = e;
                        setStateData('driverYoungSeniorityDate', _productionData.driverYoungSeniorityDate);
                        setStateData('driverYoungSeniority', _productionData.driverYoungSeniority);
                        break;
                    }
                }
            }
            
        }
    }


    const handleChange = (date: Date | null, e?: React.SyntheticEvent<any>) => {

        const inputValue = e && (e.target as HTMLInputElement).value ? (e.target as HTMLInputElement).value : '';
        const id = e && (e.currentTarget as HTMLInputElement).id ? (e.currentTarget as HTMLInputElement).id : '';
        if (inputValue.length > 0 && inputValue.length < 10) return;


        if (!date) return;

        calcAge(date, id);

    };

    const handleChangeDriverMainSeniorityDate = (date: Date | null) => {

        calcAge(date, "driverMainSeniorityDate");

    };

    const handleChangeDriverMainBirthDate = (date: Date | null) => {

        calcAge(date, "driverMainBirthDate");

    };

    const handleChangeDriverYoungBirthDate = (date: Date | null) => {

        calcAge(date, "driverYoungBirthDate");

    };

    const handleChangeDriverYoungSeniorityDate = (date: Date | null) => {

        calcAge(date, "driverYoungSeniorityDate");

    };

    const errorMessages = (fieldName: string) => {
        return renderValidationError(fieldName) ? { border: '1px solid red' } : {}
    }


    return (
        <div>
            {
                showProtection ? (
                    <ProtectionModel
                        offer={productionData.offer}
                        onClose={() => setShowProtection(false)}
                    />
                ) : ""
            }

            <section>
                <div className="section-title">
                    פרטי רכב
                </div>
                <div className="parameter-row">
                    <div className="parameter-item" style={{ maxWidth: '120px', minWidth: '120px' }}>
                        <div className="field">
                            <div className="title">
                                מספר רכב
                            </div>
                            <div className="value" style={errorMessages("licenseNumber")}>
                                <input
                                    type="text"
                                    onChange={(e: any) => setCarData("licenseNumber", e.target.value)}
                                    value={productionData != null ? productionData.vehicle.licenseNumber : ""}
                                    placeholder='שדה חובה*'
                                />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>
                                    {renderValidationError("licenseNumber")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item" style={{ maxWidth: '120px', minWidth: '120px' }}>
                        <div className="field">
                            <div className="title">
                                קוד דגם
                            </div>
                            <div className="value" style={errorMessages("modelCode")}>
                                <input type="text" onChange={(e: any) => setCarData("modelCode", e.target.valuee)} value={productionData != null && productionData.vehicle != null ? productionData.vehicle.modelCode : ""} placeholder='שדה חובה*' />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>
                                    {renderValidationError("modelCode")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item" style={{ maxWidth: '120px', minWidth: '120px' }}>
                        <div className="field">
                            <div className="title">
                                שנת ייצור
                            </div>
                            <div className="value" style={errorMessages("carYear")}>
                                <input type="text" onChange={(e: any) => setCarData("carYear", e.target.value)} value={productionData != null && productionData.vehicle != null ? productionData.vehicle.carYear : ""} placeholder='שדה חובה*' />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>
                                    {renderValidationError("carYear")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                בעלות הרכב
                            </div>
                            <div className="value">
                                {vehicleOwnership ? (<IDNameDescriptionItemSelect OnChange={setCarData} Id={"vehicleOwnership"} Options={vehicleOwnership} Value={productionData != null ? productionData.vehicle.vehicleOwnership : null} />
                                ) : ""}

                            </div>
                        </div>
                    </div>

                    {/* </div>
                <div className="parameter-row"> */}

                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם דגם
                            </div>
                            <div className="value" style={errorMessages("vehicleModel")}>
                                {/* need to check with Sara about the modelCode in vehicle object becuase we have data of model inside vehicleSubModel.name */}
                                <input
                                    type="text"
                                    onChange={(e: any) => setCarData("vehicleModel", e.target.value)}
                                    value={productionData != null && productionData.vehicle.vehicleSubModel != null && productionData.vehicle.vehicleSubModel.name != null ? productionData.vehicle.vehicleSubModel.name : ""}
                                    placeholder='שדה חובה*'
                                />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>
                                    {renderValidationError("vehicleModel")}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="parameter-item" style={{ maxWidth: '60px', minWidth: '60px' }}>
                        <div className="field">
                            <div className="title">
                                מיגון
                            </div>

                            <FileProtectOutlined style={{ fontSize: '28px', color: '#007cff' }} onClick={() => setShowProtection(true)} />

                        </div>
                    </div>

                </div>


                <div className='parameter-row'>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        רשאים לנהוג
                                    </div>
                                    <div className="value">
                                        {/* need to check with Sara about the authorizedToDrive in vehicle object */}
                                        {authorizedToDrive ? (<IDNameDescriptionItemSelect OnChange={setStateData} Id={"authorizedToDrive"} Options={authorizedToDrive} Value={productionData != null ? productionData.authorizedToDrive : null} />
                                        ) : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {productionData.authorizedToDrive == 0 || productionData.authorizedToDrive == 1 ?
                <section>
                    {/* Main Driver */}

                    <div className="section-title">
                        הנהג העיקרי
                    </div>

                    <div className="parameter-row">
                        <div className="parameter-item">
                            <div className="field">
                                <div className="text-row">
                                    <input
                                        type="checkbox"
                                        onChange={(e: any) => setCheckBox("ownerIsMainDriver", e)}
                                        checked={ownerIsMainDriver} />

                                    <div>בעל הרכב הוא הנהג העקרי</div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    שם פרטי
                                </div>
                                <div className="value" style={errorMessages("firstNameMainDriver")}>
                                    <input type="text" onChange={(e: any) => setMainDriverCustomer("driverMainFirstName", e.target.value)} value={productionData.driverMainFirstName} placeholder='שדה חובה*' />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>
                                        {renderValidationError("firstNameMainDriver")}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    שם משפחה
                                </div>
                                <div className="value" style={errorMessages("lastNameMainDriver")}>
                                    <input type="text" onChange={(e: any) => setMainDriverCustomer("driverMainLastName", e.target.value)} value={productionData.driverMainLastName} placeholder='שדה חובה*' />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>{renderValidationError("lastNameMainDriver")}</div>

                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    ת.ז
                                </div>
                                <div className="value" style={errorMessages("identifierMainDriver")}>
                                    <input type="text" onChange={(e: any) => setMainDriverCustomerIdentifier("driverMainIdentifier", e.target.value)} value={productionData.driverMainIdentifier} placeholder='שדה חובה*' />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>
                                        {renderValidationError("identifierMainDriver")}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                    <div className="parameter-row">

                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מגדר
                                </div>
                                <div className="value">
                                    {geder ? (<IDNameDescriptionItemSelect OnChange={setMainDriverCustomer} Id={"driverMainGender"} Options={geder} Value={productionData.driverMainGender} />
                                    ) : ""}
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מצב משפחתי
                                </div>
                                <div className="value">
                                    {maritalStatus ? (<IDNameDescriptionItemSelect OnChange={setMainDriverCustomer} Id={"driverMainMaritalStatus"} Options={maritalStatus} Value={productionData.driverMainMaritalStatus} />
                                    ) : ""}
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    תאריך לידה
                                </div>
                                <div className="value" style={errorMessages("driverMainBirthDate")}>
                                    <CompDatePicker value={productionData != null && productionData.driverMainBirthDate != null && !emptyDate(productionData.driverMainBirthDate) ? new Date(productionData.driverMainBirthDate) : null}
                                        onChange={handleChangeDriverMainBirthDate}
                                        ref={mainLicenseDateRef}
                                        id='driverMainBirthDate'
                                    />
                                    <div style={{ display: 'flex' }}>
                                        <div style={{
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'end',
                                            paddingTop: '5px',
                                            color: 'red'
                                        }}>
                                            {renderValidationError("driverMainBirthDate")}
                                        </div>


                                        <div>{productionData.offer && productionData.offer ? productionData.offer.driverMainBirthDate : ""}</div>
                                    </div>

                                </div>
                            </div>
                            <div className="field">
                                <div className="title">
                                    גיל
                                </div>
                                <div className="value grey-text-age">
                                    {productionData != null && productionData.driverMainBirthDate != null && !emptyDate(productionData.driverMainBirthDate) ? calculateAge(productionData.driverMainBirthDate as Date,new Date(productionData.startDate)) : null}
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    תאריך הוצאת רשיון
                                </div>
                                <div className="value" style={errorMessages("driverMainSeniorityDate")}>
                                    <CompDatePicker value={productionData != null && productionData.driverMainSeniorityDate != null && !emptyDate(productionData.driverMainSeniorityDate) ? new Date(productionData.driverMainSeniorityDate) : null}
                                        onChange={handleChangeDriverMainSeniorityDate}
                                        ref={mainLicenseDateRef}
                                        id='driverMainSeniorityDate'
                                    />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>
                                        {renderValidationError("driverMainSeniorityDate")}
                                    </div>

                                    <div>{productionData.offer && productionData.offer ? productionData.offer.driverMainSeniorityDate : ""}</div>
                                    <div className="icon small-icon calendar pointer"></div>
                                </div>
                            </div>
                            <div className="field">
                                <div className="title">
                                    ותק
                                </div>
                                <div className="value grey-text-age">
                                    {productionData != null && !emptyDate(productionData.driverMainSeniorityDate) ? calculateAge(productionData.driverMainSeniorityDate,new Date(productionData.startDate)) : ""}
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                : ""}
            {/* Young Driver */}
            {productionData.authorizedToDrive && productionData.authorizedToDrive == 1 || productionData.authorizedToDrive == 2 ?
                <section>
                    <div className="section-title">
                        הנהג הצעיר
                    </div>
                    <div className="parameter-row">
                        {productionData.authorizedToDrive == 1 &&
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="text-row">
                                        <input
                                            type="checkbox"
                                            onChange={(e: any) => setCheckBoxYoungDriver("ownerIsYoungDriver", e)}
                                            checked={ownerIsYoungDriver} />

                                        <div>בעל הרכב הוא הנהג הצעיר</div>
                                    </div>
                                </div>
                            </div>
                        }

                        {productionData.authorizedToDrive == 1 ? <>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        שם פרטי
                                    </div>
                                    <div className="value" style={errorMessages("firstNameYoung")}>
                                        <input type="text" onChange={(e: any) => setYoungDriverCustomer("driverYoungFirstName", e.target.value)} value={productionData.driverYoungFirstName} />
                                        <div style={{
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'end',
                                            paddingTop: '5px',
                                            color: 'red'
                                        }}>
                                            {renderValidationError("firstNameYoung")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        שם משפחה
                                    </div>
                                    <div className="value" style={errorMessages("lastNameYoung")}>
                                        <input type="text" onChange={(e: any) => setYoungDriverCustomer("driverYoungLastName", e.target.value)} value={productionData.driverYoungLastName} />
                                        <div style={{
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'end',
                                            paddingTop: '5px',
                                            color: 'red'
                                        }}>
                                            {renderValidationError("lastNameYoung")}
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        ת.ז
                                    </div>
                                    <div className="value" style={errorMessages("identifierYoung")}>
                                        <input type="text" onChange={(e: any) => setYoungDriverCustomerIdentifier("driverYoungIdentifier", e.target.value)} value={productionData != null ? productionData.driverYoungIdentifier : ""} />
                                        <div style={{
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'end',
                                            paddingTop: '5px',
                                            color: 'red'
                                        }}>
                                            {renderValidationError("identifierYoung")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                            : ""}


                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מגדר
                                </div>
                                <div className="value">
                                    {geder ? (<IDNameDescriptionItemSelect OnChange={setYoungDriverCustomer} Id={"driverYoungGender"} Options={geder} Value={productionData != null ? productionData.driverYoungGender : null} />
                                    ) : ""}
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מצב משפחתי
                                </div>
                                <div className="value">
                                    {maritalStatus ? (<IDNameDescriptionItemSelect OnChange={setYoungDriverCustomer} Id={"driverYoungMaritalStatus"} Options={maritalStatus} Value={productionData != null ? productionData.driverYoungMaritalStatus : null} />
                                    ) : ""}
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    תאריך לידה
                                </div>
                                <div className="value" style={errorMessages("driverYoungBirthDate")}>
                                     <CompDatePicker value={productionData != null && productionData.driverYoungBirthDate != null && !emptyDate(productionData.driverYoungBirthDate) ? new Date(productionData.driverYoungBirthDate) : null}
                                        onChange={handleChangeDriverYoungBirthDate}
                                        ref={mainLicenseDateRef}
                                        id='driverYoungBirthDate'
                                    />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>
                                        {renderValidationError("driverYoungBirthDate")}
                                    </div>

                                    
                                    <div>{productionData.offer && productionData.offer ? productionData.offer.driverYoungBirthDate : ""}</div>
                                    <div className="icon small-icon calendar pointer"></div>
                                </div>
                            </div>
                            <div className="field">
                                <div className="title">
                                    גיל
                                </div>
                                <div className="value grey-text-age">
                                    {productionData.driverYoungBirthDate != null && !emptyDate(productionData.driverYoungBirthDate) ? calculateAge(productionData.driverYoungBirthDate as Date,new Date(productionData.startDate)) : null}
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    תאריך הוצאת רשיון
                                </div>
                                <div className="value" style={errorMessages("driverYoungSeniorityDate")}>
                                    <CompDatePicker value={productionData != null && productionData.driverYoungSeniorityDate != null && !emptyDate(productionData.driverYoungSeniorityDate) ? new Date(productionData.driverYoungSeniorityDate) : null}
                                        onChange={handleChangeDriverYoungSeniorityDate}
                                        ref={mainLicenseDateRef}
                                        id='driverYoungSeniorityDate'
                                    />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>
                                        {renderValidationError("driverYoungSeniorityDate")}
                                    </div>




                                    
                                    <div>{productionData.offer && productionData.offer ? productionData.offer.driverYoungSeniorityDate : ""}</div>

                                    <div className="icon small-icon calendar pointer"></div>
                                </div>
                            </div>
                            <div className="field">
                                <div className="title">
                                    ותק
                                </div>
                                <div className="value grey-text-age">
                                    {productionData != null && !emptyDate(productionData.driverYoungSeniorityDate) ? calculateAge(productionData.driverYoungSeniorityDate,new Date(productionData.startDate)) : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                : ""}
        </div>
    )
}

export default CarAndDriversDetails